import lottie from "lottie-web";

// Lottie JSONをここにimport（追加時はここに追記）
import aboutData from "../../lottie/about/data.json";
import experienceData from "../../lottie/experience/data.json";
import photoData from "../../lottie/photo/data.json";
import gourmetData from "../../lottie/gourmet/data.json";
import coordinateData from "../../lottie/coordinate/data.json";
import entertainmentData from "../../lottie/entertainment/data.json";
import realData from "../../lottie/real/data.json";

// キーとJSONの紐付け
const animations = {
  about: aboutData,
  experience: experienceData,
  photo: photoData,
  gourmet: gourmetData,
  coordinate: coordinateData,
  entertainment: entertainmentData,
  real: realData,
};

export const lottieAnimations = () => {
  document.querySelectorAll("[data-lottie]").forEach((container) => {
    const key = container.dataset.lottie;
    const animationData = animations[key];
    if (!animationData) return;

    const anim = lottie.loadAnimation({
      container: container,
      renderer: "svg",
      loop: false,
      autoplay: false,
      animationData: animationData,
    });

    anim.setSpeed(2);

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            anim.play();
            observer.disconnect();
          }
        });
      },
      { threshold: 0.3 },
    );

    observer.observe(container);
  });
};
